import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Detalii contract',
  tabs: {
    [info_tab]: 'Info',
    [contract_tab]: 'Contract',
    [versioning_tab]: 'Versiuni',
  },
  sections: {
    price_info: 'Informații preț',
    contact: 'Contract curent',
    signature_history: 'Istoric semnături',
  },
  labels: {
    not_signed: 'Contractul nu a fost semnat încă',
  },
  modals: {
    preview_contract: {
      title: 'Previzualizare contract',
    },
    switch_to_annual: {
      title: 'Comutare la anual',
    },
  },
  buttons: {
    save: 'Salvează',
    preview_and_sign: 'Previzualizare și semnare',
    download: 'Descarcă',
    switch_to_annual: 'Comutare la anual',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    failed_to_save_changes: 'Eroare la salvarea modificărilor',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
